<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="sherlock-bones-and-the-creepy-castle">
<h1 style="margin-top:250px;font-family:Arial;">Sherlock Bones and <br/>The Creepy Castle</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?0846f3f8